import React from 'react';
import { Navbar } from '../components/Navbar';
import { ProfilePage } from '../components/ProfilePage';
import { Footer } from '../components/Footer';
export const Profile = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2361" data-mp="349rsl4y2j4q2">
      <Navbar data-id="element-2362" data-mp="34b2ut0bv84f2" />
      <ProfilePage data-id="element-2363" data-mp="347f2g4i5po1x" />
      <Footer data-id="element-2364" data-mp="39830390w5354" />
    </div>;
};